import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Skeleton } from 'primereact/skeleton';

import Dialog from '../../../shared/PFDialog/PFDialogContainer';
import { AppHeaderProps } from '../interface/app-header';
import UserSettingsDialog from '../../../Admin/Settings/UserSettingsDialog';
import Task from '../../../TaskManagement/Task';
import TaskNotification from '../TaskNotification/TaskNotificationComponent';
import { getProjectViewEditPath } from '../helpers/validation.helper';
import { checkPermission } from '../../../../utils/Helpers';
import BulletinMarquee from '../../../Admin/Bulletin/BulletinMarquee';
import styles from '../css/navbar.module.css';
import PhotoVideoFileUpload from '../UploadPhotosVideos/PhotoVideoFileUpload';
import permissions from '../../../../config/permissions';
import CxScheduleAlert from '../CxScheduleAlert';

import CompanyLogo from './CompanyLogo';
import SidebarCallButton from './SidebarCallButton';
import MainMenu from './MainMenu';
import ProjectSearchBar from './ProjectSearchBar';
import TenantProfileDrawer from './TenantProfileDrawer';
import HeaderNotifications from './HeaderNotifications';
import GlobalFilterContainer from './GlobalFilterContainer';

const AppHeader: React.FC<AppHeaderProps> = ({
  slideDrawer,
  setSlideDrawer,
  myPermission,
}) => {
  const history = useHistory();
  const urlParams = history?.location?.pathname;
  const [visible, setVisible] = useState<boolean>(false);
  const isGlobalTask = urlParams ? getProjectViewEditPath(urlParams) : null;
  const [showUserSettings, setshowUserSettings] = useState<boolean>(false);
  const [headerLoader, setHeaderLoader] = useState<boolean>(true);
  const [isLandscape, setIsLandscape] = useState(
    window.matchMedia('(orientation: landscape)').matches
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: landscape)');
    const handler = (e: MediaQueryListEvent) => {
      const isSmallHeight = window.innerHeight <= 500;
      setIsLandscape(e.matches && isSmallHeight);
    };
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const handleUserSettingsVisibility = (value: boolean) => {
    setshowUserSettings(value);
  };

  const userId = localStorage.getItem('user_id');

  useEffect(() => {
    if (userId) {
      setHeaderLoader(false);
    } else {
      setHeaderLoader(false);
    }
  }, [userId]);
  const isWebAccessDenied = urlParams === '/web-access-denied';

  if (isWebAccessDenied && !myPermission) {
    history.push('/dashboard');
  }
  return (
    <>
      <PhotoVideoFileUpload />
      {headerLoader ? (
        <div className="flex justify-content-around mt-1 justify-content-between">
          <Skeleton width="18%" className="mb-2 h-4rem"></Skeleton>
          <Skeleton width="60%" className="mb-2 h-4rem"></Skeleton>
          <Skeleton width="18%" className="mb-2 h-4rem"></Skeleton>
        </div>
      ) : (
        <header
          className={`app-header fixed h-6rem md:h-5rem right-0 grid grid-nogutter z-200 transition-ease-in-out transition-duration-500 shadow-1 ${isLandscape && 'landscape-view'} ${slideDrawer && styles.mobileHeader} ${styles.smallSidebar}`}
        >
          <CompanyLogo />

          <div className="col px-0 xl:pl-1 justify-content-center hidden lg:flex">
            {!myPermission && <ProjectSearchBar setVisible={setVisible} />}
          </div>

          <div className="col-12 md:col lg:col-fixed lg:w-auto pl-1 xl:pl-2 pr-2 md:pr-3 align-items-center flex border-top-1 md:border-none border-200">
            <div className="flex w-12">
              {!myPermission && (
                <>
                  <div className="inline-flex lg:hidden align-items-center md:bg-white border-round-xl mx-2 md:px-3 md:shadow-2 md:mr-1">
                    <i
                      className="pi pi-search text-primary cursor-pointer"
                      onClick={() => setVisible(true)}
                    ></i>
                  </div>
                  <HeaderNotifications />
                </>
              )}

              {!myPermission && <GlobalFilterContainer />}
              <TenantProfileDrawer
                handleUserSettingsVisibility={handleUserSettingsVisibility}
                myPermission={myPermission}
              />
            </div>
          </div>
          <Dialog
            visible={visible}
            className={`${styles.projectSearch} w-11 h-full shadow-none`}
            onHide={() => {
              if (!visible) return;
              setVisible(false);
            }}
            dismissableMask
            pt={{
              header: {
                className: 'p-0 bg-transparent',
              },
              content: {
                className: 'p-0 bg-transparent',
              },
              closeButton: {
                className: 'bg-primary-500 text-white',
              },
            }}
            position="top"
          >
            <ProjectSearchBar setVisible={setVisible} />
          </Dialog>
        </header>
      )}
      <div className="h-6rem md:h-5rem"></div>

      <MainMenu
        slideDrawer={slideDrawer}
        setSlideDrawer={setSlideDrawer}
        isLandscape={isLandscape}
      />
      {checkPermission(permissions?.autoScheduling?.viewBanner) && (
        <CxScheduleAlert />
      )}

      <BulletinMarquee />
      <div className={`${!slideDrawer && 'hidden md:flex'}`}>
        <Task myPermission={myPermission} />
        <SidebarCallButton myPermission={myPermission} />
      </div>
      <UserSettingsDialog
        showDialog={showUserSettings}
        handleCloseDialogue={handleUserSettingsVisibility}
        defaultTabIndex={0}
      />
      {isGlobalTask === false ? <TaskNotification /> : null}
    </>
  );
};

export default AppHeader;
